module.exports = __webpack_public_path__ + "static/media/dot.ad99906b.svg";